import { PhysicianPortalEventType } from './PhysicianPortalEventType.js';

const _items = Symbol();

export class PhysicianPortalEventTypes {
	constructor(...items) {
		this[_items] = [];

		this.add(...items);
	}
	//iterator protocol support
	*iterator() {
		for(let key in this[_items]) {
			let value = this[_items][key];
			yield value;
		}
	}
	//iterable protocol support
	[Symbol.iterator]() {
		return this.iterator();
	}
	add(...items) {
		items.forEach((item, index) => {
			if(!(item instanceof PhysicianPortalEventType))
				throw new TypeError(`argument at index ${index} must be an instance of PhysicianPortalEventType.`);
		});
		this[_items].push(...items);
	}
	get(index) {
		if(!Number.isInteger(index))
			throw new TypeError('index must be an integer.');
		
		return this[_items][index];
	}
	toJSON() {
		return this[_items].slice(0);
	}
	static fromArray(arr) {
		if(!Array.isArray(arr))
			throw new TypeError('arr must be an array.');
		return new this(
			...arr.map(v => PhysicianPortalEventType.fromObject(v))
		);
	}
}